import { ORG_ID } from '@@types/common';
import { Organization } from '@@types/Organization';

import { URLS } from '~/constants';
import Api2 from '~/stores/providers/Api2';

class OrganizationApi {
  constructor(private api: Api2) {}

  fetchOrganizationById = (orgId: ORG_ID): Promise<Organization> => {
    return this.api.contentsRequester.get(`${URLS.WAS_API}/organizations/!${orgId}`);
  };

  fetchTenantOrganizationCount = (): Promise<{ totalCount: number }> => {
    return this.api.resultRequester.get(`${URLS.WAS_API}/organizations?size=1`);
  };
}

export default OrganizationApi;
